<template>
  <div class="text-center py-5">
    <div class="mb-4" style="font-size: 64px; opacity: 0.3;">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
    </div>
    <h3>Your cart is empty</h3>
    <p class="text-muted mb-4">Browse our marketplace to find live fish, plants, and supplies.</p>
    <a href="/" class="btn btn-primary">Browse Listings</a>
  </div>
</template>

<script>
export default {};
</script>
